import Mt5View from "@/views/mt5/Mt5View";
import Mt5Details from "@/views/mt5/Mt5Details";
import ChangeMt5Password from "@/views/mt5/ChangeMt5Password";

export default { Mt5View, Mt5Details, ChangeMt5Password };
